// ─────────────────────────────────────────────
//  WatchlistSnapshot.js — Dashboard watchlist widget
// ─────────────────────────────────────────────
import React from "react";
import { useNavigate } from "react-router-dom";
import { useWatchlist } from "../../hooks/useWatchlist";
import "./WatchlistSnapshot.css";

export default function WatchlistSnapshot() {
  const { items, liveData, loading } = useWatchlist();
  const navigate = useNavigate();

  const top5 = items.slice(0, 5);

  return (
    <div className="ws-wrap">
      <div className="ws-header">
        <span className="ws-title">My Watchlist</span>
        <button className="ws-link" onClick={() => navigate("/watchlist")}>
          Manage →
        </button>
      </div>

      {loading ? (
        <div className="ws-rows">
          {Array.from({ length: 4 }).map((_, i) => (
            <div className="ws-skel-row" key={i}>
              <div className="ws-skel w50" />
              <div className="ws-skel w30" />
            </div>
          ))}
        </div>
      ) : top5.length === 0 ? (
        <div className="ws-empty">
          <div className="ws-empty-icon">👁</div>
          <p>No stocks in watchlist</p>
          <button className="ws-add-btn" onClick={() => navigate("/watchlist")}>
            Add Stocks →
          </button>
        </div>
      ) : (
        <div className="ws-rows">
          {top5.map((item) => {
            const live   = liveData[item.symbol];
            const cmp    = live?.price ? parseFloat(live.price) : null;
            const target = item.target_entry_price ? parseFloat(item.target_entry_price) : null;
            const dist   = cmp && target ? (((cmp - target) / target) * 100).toFixed(1) : null;
            const isUp   = live ? parseFloat(live.change) >= 0 : null;

            return (
              <div
                className="ws-row"
                key={item.id}
                onClick={() => navigate(`/stock/${item.symbol}`)}
              >
                <div className="ws-row-left">
                  <span className="ws-sym">{item.symbol}</span>
                  <span className="ws-exch">{item.exchange || "NSE"}</span>
                </div>
                <div className="ws-row-right">
                  {cmp ? (
                    <>
                      <span className="ws-price">
                        ₹{cmp.toLocaleString("en-IN", { maximumFractionDigits: 2 })}
                      </span>
                      {isUp !== null && (
                        <span className={`ws-chg ${isUp ? "up" : "down"}`}>
                          {isUp ? "▲" : "▼"} {Math.abs(parseFloat(live.change_percent || 0)).toFixed(2)}%
                        </span>
                      )}
                      {dist !== null && (
                        <span className={`ws-dist ${parseFloat(dist) <= 0 ? "reached" : ""}`}
                          title="Distance to your target entry price"
                        >
                          {parseFloat(dist) > 0 ? `${parseFloat(dist).toFixed(1)}% to entry` : "At/below entry ✓"}
                        </span>
                      )}
                    </>
                  ) : (
                    <span className="ws-loading">—</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}